export type Task = {
	id: string;
	title: string;
	plantId: string;
	plantName: string;
	dueAt: string;
	status: 'todo' | 'in_progress' | 'done';
};

export const tasks: Task[] = [
	{ id: 't1', title: 'Water Aloe', plantId: 'p1', plantName: 'Aloe Vera', dueAt: new Date(Date.now() + 86400000).toISOString(), status: 'todo' },
	{ id: 't2', title: 'Prune Snake Plant', plantId: 'p2', plantName: 'Snake Plant', dueAt: new Date(Date.now() + 86400000 * 2).toISOString(), status: 'in_progress' },
	{ id: 't3', title: 'Fertilize Peace Lily', plantId: 'p3', plantName: 'Peace Lily', dueAt: new Date(Date.now() + 86400000 * 5).toISOString(), status: 'todo' },
	{ id: 't4', title: 'Check Monstera Soil', plantId: 'p4', plantName: 'Monstera', dueAt: new Date(Date.now() - 86400000).toISOString(), status: 'done' },
	{ id: 't5', title: 'Harvest Basil', plantId: 'p5', plantName: 'Basil', dueAt: new Date(Date.now() + 86400000 * 3).toISOString(), status: 'todo' }
];


